<template>
  <div class="index-card">
    <img :src="img" alt="img" @click="clickHanlder">
    <div class="detail">
      <div class="detail__title" @click="clickHanlder">
        <span v-show="name" class="detail__name">{{ name }}</span>
        <span v-show="office" class="detail__office">{{ office }}</span>
      </div>
      <div class="detail__footer">
        <div class="detail__times">{{ times || 0 }}次浏览</div>
        <div class="detail__btn">
          <slot name="operator"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexCard',
  props: {
    img: {
      type: String,
      defalut: '',
    },
    name: {
      type: String,
      defalut: '',
    },
    office: {
      type: String,
      defalut: '',
    },
    times: {
      type: Number,
      defalut: '',
    },
  },
  methods: {
    clickHanlder () {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.index-card {
  width: 282px;
  height: 252px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  transition: .3s ease-in;
  img {
    display: block;
    width: 100%;
    height: 160px;
    cursor: pointer;
  }
  .detail {
    padding: 18px 16px;
    box-sizing: border-box;
    font-family: PingFangSC-Regular, PingFang SC;
    &__title {
      margin-bottom: 12px;
      font-size: 14px;
      line-height: 16px;
      height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      &:hover .detail__name, &:hover .detail__office {
        color: #fa8919;
      }
    }
    &__name {
      font-weight: 600;
      color: #333333;
      margin-right: 8px;
    }
    &__office {
      font-weight: 400;
      color: #666666;
    }
    &__footer {
      display: flex;
      justify-content: space-between;
    }
    &__times {
      font-size: 13px;
      color: #999999;
      line-height: 18px;
    }
    &:deep(.vui-btn) {
      background: #FA8919;
      border-radius: 16px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      border: none;
      .ivu-icon-md-lock {
        display: none;
      }
      &.disable {
        cursor: not-allowed;
        background: #999EA3;
        border: 1px solid #999EA3;
        padding: 6px 16px 6px 12px;
        .ivu-icon-md-lock {
          display: inline;
        }
        &:hover {
          background: #999EA3;
        }
      }
      &:hover {
        background: #FA9A2A;
      }
    }
    &:deep(.ivu-icon.ivu-icon-md-lock) {
      position: relative;
      top: -1px;
      margin-right: 2px;
    }
  }
  &:hover {
    box-shadow: 0px 4px 16px 0px rgba(21,31,41,0.16);
  }
}
</style>

<style lang="scss">
.hover-card {
  .ivu-poptip-content {
    box-shadow: 2px 6px 12px 0px rgba(21, 31, 41, 0.08);
  }
  .ivu-poptip-body {
    padding: 0;
  }
  .ivu-poptip-inner {
    border-radius: 8px;
  }
  &.ivu-poptip-popper .ivu-poptip-arrow {
    top: 30px;
  }
  .card {
    white-space: pre-wrap;
    padding: 16px 16px 20px;
    &__title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      margin: 0 0 12px;
    }
    &__tag {
      display: inline-block;
      padding-inline: 8px;
      height: 24px;
      background: #F2F3F5;
      border-radius: 4px;
      line-height: 24px;
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-bottom: 16px;
      &:not(:last-child) {
        margin-right: 8px;
      }
    }
    &__authors {
      border-top: 1px solid #F2F4F7;
    }
    &__author {
      display: flex;
      padding-block: 16px;
      border-bottom: 1px solid #F2F4F7;
      &-detail {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    &__avatar {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: 10px;
    }
    &__name {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin-bottom: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &__office {
      font-size: 12px;
      color: #999999;
      line-height: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &__desc {
      font-size: 12px;
      color: #999999;
      line-height: 18px;
      margin-block: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
    }
    &__btn {
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
      cursor: pointer;
      color: #FA8919;
      &:hover {
        color: #ED6C00;

      }
    }
  }
}
</style>
